const orderEndpoints = {
  list: () => '/virtualtrading/order',
  create: (type: 'buy' | 'sell', symbol: string) =>
    `/virtualtrading/${type}/${symbol}`,
  amend: () => '/virtualtrading/amend',
};

export default orderEndpoints;
